<template>
  <div
    class="nights-two-columns-component flex flex-col xl:flex-row xl:flex-start"
  >
    <div class="w-full mb-10 xl:w-2/3">
      <slot name="left"></slot>
    </div>
    <div class="right-col hidden xl:block w-full xl:w-1/3 xl:self-start xl:mt-1" ref="right">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  data() {
    return {
      top: 0,
      isDesktop: false,
    };
  },

  computed: {
    transform() {
      if (!this.isDesktop) {
        return "none";
      }

      return `translateY(${this.top}px)`;
    },
  },

  mounted() {
    this.$nextTick(() => {
      const { top } = this.$refs.right.getBoundingClientRect();
      window.addEventListener(
        "scroll",
        _.throttle(() => {
          if (window.scrollY > top - 30) {
            let newTop = (window.scrollY - top + 30) * -1;
            if (newTop < 0) {
              newTop *= -1;
            }
            this.top = newTop;
          }
        }, 100)
      );
    });

    const mql = window.matchMedia("(min-width: 1280px)");
    this.isDesktop = mql.matches;
    mql.addEventListener("change", ({ matches }) => {
      this.isDesktop = matches;
    });
  },
};
</script>

<style scoped lang="scss">
.nights-two-columns-component {
  > div + div {
    @media (min-width: 1280px) {
      margin-left: 4rem;
    }
    @media (min-width: 1440px) {
      margin-left: 5rem;
    }
  }

  .right-col {
    // transition: transform 0.3s ease;
    position: sticky;
    top: 0;
  }
}
</style>
